// extracted by mini-css-extract-plugin
export default {"root":"Report-root","stats":"Report-stats","stat":"Report-stat","label":"Report-label","adInfo":"Report-adInfo"};